import styled from '@emotion/styled';

export const DottedDivider = styled.hr`
  border: none;
  border-bottom: 1px dotted #999;
`;
